import { render, staticRenderFns } from "./ProfilPage.vue?vue&type=template&id=a991f930&scoped=true&"
import script from "./ProfilPage.vue?vue&type=script&lang=js&"
export * from "./ProfilPage.vue?vue&type=script&lang=js&"
import style0 from "./ProfilPage.vue?vue&type=style&index=0&id=a991f930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991f930",
  null
  
)

export default component.exports